<script setup lang="ts">
import PromptPlaygroundPage from './PromptPlaygroundPage.vue';
</script>

<template>
  <div class="min-h-full bg-linear-to-br from-slate-50 to-blue-50 p-6">
    <div class="mx-auto max-w-7/8 2xl:max-w-6/8">
      <PromptPlaygroundPage />
    </div>
  </div>
</template>
